import { render, staticRenderFns } from "./ErrorLabel.vue?vue&type=template&id=6e457242&scoped=true&lang=pug&"
import script from "./ErrorLabel.vue?vue&type=script&lang=coffee&"
export * from "./ErrorLabel.vue?vue&type=script&lang=coffee&"
import style0 from "./ErrorLabel.vue?vue&type=style&index=0&id=6e457242&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e457242",
  null
  
)

export default component.exports